import Footer from 'layout/footer';
import Header from 'layout/header';
import { Fragment } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const HelpCenterHi = () => {

    return (
        <Fragment>
    <Card.Header as="h5">सहायता केंद्र</Card.Header>
    <Card.Body className='p-4'>
        <div>
            <p><b>अंतिम अपडेट: [30 अप्रैल 2025]</b></p>

            <p><strong>लोरम डिजिटल ऐप </strong> में आपका स्वागत है। यह केवल डमी सामग्री है जिसका उद्देश्य डिज़ाइन और लेआउट को दर्शाना है। कृपया इस सामग्री को वास्तविक कानूनी दस्तावेज़ न समझें।</p>

            <p><strong>1. शर्तों की स्वीकृति</strong><br />
                उपयोगकर्ता इस डमी पाठ को पढ़कर केवल उदाहरण स्वरूप शर्तों की कल्पना कर सकता है। यह सामग्री किसी भी कानूनी प्रभाव की दावेदारी नहीं करती है।</p>

            <p><strong>2. शर्तों में परिवर्तन</strong><br />
                समय-समय पर डमी शब्दों को अद्यतन किया जा सकता है। उदाहरण के लिए: लोरम इप्सम डोलर सिट अमेट, कंसेक्टेचर अडिपिसिंग एलिट।</p>

            <p><strong>3. प्रदान की गई सेवाएं</strong><br />
                लोरम डिजिटल ऐप केवल मॉक सेवाओं का वर्णन करता है। इन सेवाओं में टेक्स्ट, बॉक्स, बटन, और अन्य दृश्य घटक शामिल हो सकते हैं।</p>

            <p><strong>4. उपयोगकर्ता खाते</strong><br />
                यदि आप एक डमी खाता बनाते हैं, तो यह केवल यूआई के परीक्षण हेतु प्रयुक्त होगा। असली डेटा यहाँ संग्रहीत नहीं किया जाता है।</p>

            <p><strong>5. सेवाओं का उपयोग</strong><br />
                सभी उपयोग केवल गैर-व्यावसायिक उद्देश्यों हेतु सीमित हैं। डमी लिस्ट नीचे दी गई है:</p>
            <ul style={{ marginLeft: '1rem' }}>
                <li> • लोरम डोलर सिट अमेट।</li>
                <li> • कंसेक्टेचर अडिपिसिंग एलिट।</li>
                <li> • सस्पेंडिसे पोतेनटि नेउक।</li>
            </ul> <br />

            <p><strong>6. सामग्री का स्वामित्व और बौद्धिक संपदा</strong><br />
                यह डमी टेक्स्ट कॉपीराइट या ट्रेडमार्क अधिकारों का उल्लंघन नहीं करता है। यहां दी गई सभी जानकारी केवल उदाहरण स्वरूप है।</p>

            <p><strong>7. तृतीय-पक्ष सेवाएं</strong><br />
                किसी भी थर्ड पार्टी सेवा का उल्लेख केवल दृश्य प्रयोजनों के लिए किया गया है। असली सेवा प्रदाताओं से कोई संबंध नहीं है।</p>

            <p><strong>8. गोपनीयता नीति</strong><br />
                यह डमी गोपनीयता नीति कोई असली डेटा नहीं एकत्र करती। सभी जानकारी केवल डमी कंटेंट है।</p>

            <p><strong>9. शुल्क और भुगतान</strong><br />
                कोई भी शुल्क या भुगतान विवरण काल्पनिक है। भुगतान प्रक्रिया केवल यूआई डिज़ाइन के लिए प्रयुक्त होती है।</p>

            <p><strong>10. समाप्ति और निलंबन</strong><br />
                डमी उपयोगकर्ता कभी भी सेवाओं को समाप्त कर सकता है। कोई वास्तविक प्रतिबंध लागू नहीं होता है।</p>

            <p><strong>11. अस्वीकरण</strong><br />
                यह सेवा "जैसी है वैसी" स्थिति में दी गई है। कोई वास्तविक समर्थन या ज़िम्मेदारी नहीं ली जाती है।</p>

            <p><strong>12. उत्तरदायित्व की सीमा</strong><br />
                कोई कानूनी दावा मान्य नहीं है क्योंकि यह केवल डमी टेक्स्ट है जिसका उद्देश्य केवल प्रदर्शन है।</p>

            <p><strong>13. क्षतिपूर्ति</strong><br />
                कोई वास्तविक हानि या दावे लागू नहीं होते हैं। यह केवल यूआई टेम्पलेटिंग का हिस्सा है।</p>

            <p><strong>14. लागू कानून</strong><br />
                सभी कानूनी संदर्भ केवल मॉकअप उद्देश्यों के लिए हैं। यह किसी क्षेत्राधिकार में वैध नहीं है।</p>

            <p><strong>15. फोर्स मेजर</strong><br />
                प्राकृतिक घटनाएं, तकनीकी कठिनाइयाँ आदि केवल दर्शाने के लिए जोड़ी गई हैं।</p>

            <p><strong>16. पृथकता</strong><br />
                किसी भी अमान्य प्रावधान को हटाया जा सकता है बिना असली प्रभाव के।</p>

            <p><strong>17. संपूर्ण समझौता</strong><br />
                यह पूरा टेक्स्ट केवल एक डमी समझौते का उदाहरण है और किसी प्रकार का वास्तविक अनुबंध नहीं है।</p>

            <p><strong>18. संपर्क जानकारी</strong><br />
                यदि आपके कोई प्रश्न हैं, तो कृपया इनसे संपर्क न करें क्योंकि यह केवल डमी डेटा है:<br />
                <strong>लोरम डिजिटल ऐप सहायता</strong><br />
                [ईमेल] : support@loremapp.in <br />
                [फोन]: 0000-000000 </p>

            <p><strong>इस डमी ऐप का उपयोग करके, आप सहमत होते हैं कि आपने यह केवल यूआई मॉकअप के उद्देश्य से पढ़ा है।</strong></p>
        </div>
    </Card.Body>
</Fragment>
    );
};

export default HelpCenterHi;
